import type { CSSProperties } from 'react';

import { T } from '../styles/tokens';
import { haptic } from '../telegram/sdk';

export type Tab = 'dashboard' | 'purchase' | 'instructions' | 'more';

interface Props {
  active: Tab;
  onChange: (tab: Tab) => void;
}

const items: { id: Tab; label: string; icon: string }[] = [
  { id: 'dashboard', label: 'Подписки', icon: '▦' },
  { id: 'purchase', label: 'Купить', icon: '＋' },
  { id: 'instructions', label: 'Инструкция', icon: '?' },
  { id: 'more', label: 'Ещё', icon: '⋯' },
];

export default function BottomNav({ active, onChange }: Props) {
  return (
    <nav style={n.nav}>
      {items.map((it) => {
        const on = active === it.id;
        return (
          <button
            key={it.id}
            style={n.btn}
            onClick={() => {
              haptic('light');
              onChange(it.id);
            }}
          >
            <span style={{ ...n.icon, color: on ? T.accent : T.textMuted }}>{it.icon}</span>
            <span style={{ ...n.label, color: on ? T.accent : T.textMuted }}>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

const n: Record<string, CSSProperties> = {
  nav: {
    display: 'flex',
    background: T.surface,
    borderTop: `1px solid ${T.border}`,
    padding: '8px 0 12px',
    paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
    flexShrink: 0,
  },
  btn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px 0',
  },
  icon: { fontSize: 20, fontFamily: 'DM Mono, monospace', transition: 'color 0.15s' },
  label: { fontFamily: 'DM Mono, monospace', fontSize: 10, letterSpacing: '0.04em', transition: 'color 0.15s' },
};
